import styled from 'styled-components'


export const ContainerSpace = styled.div`
    background-color: var(--background-three);
    color: var(--text-body);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 5rem;
    padding-bottom: 3rem;

    h1 {
        font-style: normal;
        font-weight: 400;
        font-size: 70px;
        line-height: 60px;
    }
    p {
        box-sizing: border-box;
        max-width: 90vw;
        margin: 0 auto;
        padding-top: 2.5rem;
        /* padding-bottom: 2.5rem; */
        text-align: center;
    }
    img {
        margin-top: 2.5rem;
        margin-bottom: 2.5rem;
    }


    @media(max-width: 320px) {
        h1 {
            font-size: 48px;
        }
    }

`

export const Cards = styled.div`
    max-width: 95vw;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;

    .inner-card{
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }

    .inner-card:first-child {
        padding-right: 1rem;

    }

    .inner-card img:first-child {
        padding-right: 1rem;
    }

    img {
        padding-top: 1rem;
    }

    @media(max-width: 1300px) {
        .inner-card:first-child {
        padding-right: 0rem;
        }
    }
    @media(max-width: 638px) {
        .inner-card img:first-child {
        padding-right: 0rem;
        }
    }
`

export const Button = styled.div`
    background-color: var(--text-title);
    width: 325px;
    height: 56px;
    border-radius: 40px;
    margin-top: 0.75rem;
    margin-bottom: 1.75rem;
    text-align: center;

    a {
        color: var(--text-pink);
        font-family: 'Graphik';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 54px;
        margin-left: 0rem;
    }

    @media(max-width: 320px) {
        width: 276px;
    }


`